import React, {useEffect, useState} from 'react'
import PropTypes from 'prop-types';
import {Container, CssBaseline} from '@mui/material';
import {ThemeProvider} from '@mui/material/styles'

import LayoutHeader from './components/LayoutHeader'
import LayoutFooter from './components/LayoutFooter'
import LayoutMenu from './components/LayoutMenu'
import {useStyles} from './styles'
import {useMyself} from "../context/MyselfContext";

/**
 * Container component for Layout feature
 *
 * @param {*} props
 */
const Layout = ({ children, path }) => {
  const classes = useStyles();
  const [menuOpen, setMenuOpen] = useState(false)
  const {custheme, AppMenuItems} = useMyself()

  // close mobile menu after navigation
  useEffect(() => {
    setMenuOpen(false)
  }, [path])

  return (
    <ThemeProvider theme={custheme}>
      <CssBaseline />
      <LayoutHeader
        classes={classes}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
      />
      <LayoutMenu
        classes={classes}
        menuOpen={menuOpen}
        setMenuOpen={setMenuOpen}
        items={AppMenuItems || []}
      />
        <main key={'main'} className={classes.content}>
          <Container>
            {children}
          </Container>
        </main>
      <LayoutFooter />
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
}


export default Layout;
